var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('h1',[_vm._v(_vm._s(this.contents.find(content => content.id_content === 175)?.title))]),_c('div',{domProps:{"innerHTML":_vm._s(this.contents.find(content => content.id_content === 175)?.description)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }